// extracted by mini-css-extract-plugin
export default {"commentBox":"k6YlpC","withPadding":"te9Tfi"};